export const types = {
  OPEN_MOBILENAVBAR: 'OPEN_MOBILENAVBAR',
  CLOSE_MOBILENAVBAR: 'CLOSE_MOBILENAVBAR',
}
